module.exports = __webpack_public_path__ + "static/media/ig.f27d8b99.jpg";